// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cspvympuvqbiohwqvgjy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNzcHZ5bXB1dnFiaW9od3F2Z2p5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYwODg1MDIsImV4cCI6MjA1MTY2NDUwMn0.SKbPCTtZZiWB9un64tBTDELfnnoWeOTICp7QWk78tTY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);